import type { GettextFn } from "@/types";

export const emailFooter = (gettext: GettextFn) => {
  return `
  <tr>
    <td>
      <div style="border-bottom: 1px solid #e5e7eb; height: 1px;"></div>
    </td>
  </tr>
  <tr>
    <td style="color: #9ca3af;">
      ${gettext("Did you get this email by mistake? If so no worries - you can just ignore it.")}
    </td>
  </tr>
  <tr>
    <td style="font-size: 24px; color: #374151; font-weight: bold;">
      ${gettext("Questions?")}
    </td>
  </tr>
  <tr>
    <td style="color: #9ca3af;">
      ${gettext("Feel free to reach out to Customer Service. They are around 24/7 to help you.")}
    </td>
  </tr>
  <tr>
    <td style="padding-bottom: 40px; color: #000; font-size: 16px;">
      <div>
        <img src="https://app.fabeke.com/media/power-stars-black.png" alt="Stars" height="20" />
      </div>
      <div>
        <span>
          ${gettext("Data Delivered By")}
        </span>
        <span style="font-weight: 700;">
          <a href="https://fabeke.com" style="text-decoration: none; color: #000;">
            ${gettext("Fabeke")}
          </a>
        </span>
      </div>
    </td>
  </tr>
</table>
</body>
</html>`;
};
